import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PlanskaKalkulacijaService {
  constructor(private _http: HttpClient) {}

  dohvatiPlan(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jedan_planproizvodnje', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProcese(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_proces', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveStrojeve(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress +
          'dohvacanje_svih_procesastroja_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  dohvatiProcese(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvacanje_ppprocesa', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveDjelatnike(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress + 'dohvacanje_svih_djelatnika_planska_kalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  urediProces(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredivanje_procesa_planskakalkulacija', a)
      .pipe(map((res: any) => res));
  }

  dodajProces(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dodavanje_novog_procesa', a)
      .pipe(map((res: any) => res));
  }

  obrisiProces(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'brisanje_procesa_planskakalkulacija', a)
      .pipe(map((res: any) => res));
  }

  dohvatiStrojeve(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvacanje_ppstroj', a)
      .pipe(map((res: any) => res));
  }

  urediStroj(a: any) {
    return this._http
      .put(
        AppConfig.ipAddress + 'uredivanje_procesa_stroja_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  dodajStroj(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress +
          'dodavanje_novog_procesa_stroja_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  dohvatiNormative(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvacanje_normativa', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDjelatnike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvacanje_djelatnikaplana', a)
      .pipe(map((res: any) => res));
  }

  urediDjelatnika(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredivanje_djelatnika_planskakalkulacija', a)
      .pipe(map((res: any) => res));
  }

  dodajDjelatnika(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress + 'dodavanje_novog_djelatnika_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  dohvatiPredlozakStroja(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress + 'dohvacanje_procesastroja_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  dohvatiPredlozakProces(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvacanje_proces_planskakalkulacija', a)
      .pipe(map((res: any) => res));
  }

  obracunajKalkulaciju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'uredivanje_planske_kalkulacije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiOTP(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress +
          'dohvacanje_ostalih_troskova_proizvodnje_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  dodajOTP(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress +
          'dodavanje_ostalih_troskova_proizvodnje_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  urediOTP(a: any) {
    return this._http
      .put(
        AppConfig.ipAddress +
          'uredivanje_ostalih_troskova_proizvodnje_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  obrisiOTP(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress +
          'brisanje_ostalih_troskova_proizvodnje_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  urediNormativ(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'odstupanje_kolicina_normativ', a)
      .pipe(map((res: any) => res));
  }

  updateTroskovnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'ukupnasuma_planskakalkulacija', a)
      .pipe(map((res: any) => res));
  }

  dohvatiTroskovnik(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_ukupnusumu_planskekalkulacije', a)
      .pipe(map((res: any) => res));
  }

  dodajNapomenuPlanskakalkulacija(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dodaj_napomenu_planskakalkulacija', a)
      .pipe(map((res: any) => res));
  }

  datotekaUpload(a:any){
    return this._http.post(AppConfig.ipAddress + 'spremi_dokument', a)
      .pipe(map((res: any) => res ));
  }

  datotekaPopis(a:any){
		return this._http.post(AppConfig.ipAddress + 'dohvati_dokument' , a)
      .pipe(map((res: any) => res ));
  }

  datotekaObrisi(a:any){
		return this._http.post(AppConfig.ipAddress + 'obrisi_dokument' , a)
      .pipe(map((res: any) => res ));
  }

}
